import CancelAssessment from "../../../../assets/images/pre-assessment.svg";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

const FeedbackRequiredModal = (props) => {
  const {show , handleGiveFeedBack , handleExit} = props;

  return (
    <>
      <Modal visible={show}>
        <div className={styles["feedback-wrapper"]}>
          <div className={styles["success-image"]}>
            <img src={CancelAssessment} alt="success" />
          </div>
          <div className={styles.title}>Feedback Required</div>
          <div className={styles.description}>
            Please share your feedback to finish the course and Unlock screening
          </div>

          <div className={styles["button-wrapper"]}>
            <Button
              label="Give Feedback"
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleGiveFeedBack}
            />
            <Button
              label="Exit"
              buttonVariant={BUTTON_VARIANTS.SECONDARY}
              onClick={handleExit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FeedbackRequiredModal;
